import { useState } from 'react'

export const ratings = [0, 1, 2, 3, 4, 5] as const
export const sizes = [
  'xxs',
  'xs',
  's',
  'm',
  'l',
  'xl',
  'xxl',
  '3xl',
  '4xl',
] as const

export const useReviewFilters = () => {
  const [filters, setFilters] = useState<{
    rating: (typeof ratings)[number] | null
    usualSize: (typeof sizes)[number] | null
    purchasedSize: (typeof sizes)[number] | null
  }>({
    rating: null,
    usualSize: null,
    purchasedSize: null,
  })

  const setFilter = (
    filter: 'rating' | 'usualSize' | 'purchasedSize',
    value: (typeof ratings)[number] | (typeof sizes)[number] | null
  ) => {
    setFilters((prev) => ({
      ...prev,
      [filter]: value,
    }))
  }

  return {
    filters,
    setFilter,
  }
}
